"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PeopleIcon_1 = __importDefault(require("../icons/PeopleIcon"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Wrapper = styled_components_1.default.div `
  cursor: pointer;
  width: 100%;
  justify-content: space-between;
  padding: 1.5rem;
  border-radius: 1rem;
  display: grid;
  grid-template-columns: 0.25fr 1fr 0.75fr 0.5fr;
  align-items: center;
  gap: 1rem;
  min-height: 5.625rem;
  background-color: white;
`;
const ButtonWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  fill: #bbb;
  transition: 0.15s all ease;

  &:hover {
    fill: #8e8e8e;
  }
`;
const LogoWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`;
const TitleWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  > .title {
    font-size: 1rem;
    margin: 0;
  }

  > span.title {
    font-size: 0.75rem;
    margin: 0;
  }
  > .subtitle {
    font-size: 0.75rem;
    font-weight: 400;

    > .ppo-id {
      color: #bbb;
    }
  }
`;
const Ppo = ({ ppo, onClick, onOpenRolesManager }) => {
    return (react_1.default.createElement(Wrapper, { onClick: onClick },
        react_1.default.createElement(LogoWrapper, null,
            react_1.default.createElement("img", { height: 24, src: ppo.logo || '', alt: "logo" })),
        react_1.default.createElement(TitleWrapper, null,
            react_1.default.createElement("h3", { className: "title" }, ppo.organizationProfileName),
            react_1.default.createElement("span", { className: "subtitle" },
                ppo.organizationName,
                " ",
                react_1.default.createElement("span", { className: "ppo-id" },
                    "(",
                    ppo.ppo,
                    ")"))),
        react_1.default.createElement(TitleWrapper, null,
            react_1.default.createElement("span", { className: "title" }, ppo.displayName),
            react_1.default.createElement("span", { className: "subtitle" },
                react_1.default.createElement("span", { className: "ppo-id" }, ppo.role))),
        react_1.default.createElement(ButtonWrapper, null,
            react_1.default.createElement(PeopleIcon_1.default, { onClick: onOpenRolesManager }))));
};
exports.default = Ppo;
